import { useEffect } from 'react';
import styled from 'styled-components';
import { useEditor } from '../../hooks/useEditor';
import { TextButton } from '../generic/TextButton';
import { Dialog } from '../generic/dialog/Dialog';

export const OnboardingModal = () => {
  const { UI, setUI } = useEditor();

  useEffect(() => {
    const wasClosed = localStorage.getItem('wasOboardingModalClosed');
    if (!wasClosed) setUI({ ...UI, isOnboardingModalOpen: true });
  }, []);

  const closeModal = () => {
    localStorage.setItem('wasOboardingModalClosed', 'true');
    setUI({ ...UI, isOnboardingModalOpen: false });
  };

  return (
    <Dialog
      title="Quick Start Guide"
      description="Don't know where to start? We'll guide you through the basics"
      open={UI.isOnboardingModalOpen}
      setOpen={(value) => setUI({ ...UI, isOnboardingModalOpen: value })}
      cancelElement={<TextButton>Remind me later</TextButton>}
      actionElement={
        <TextButton handleClick={closeModal} type="accent">
          All right, let's go!
        </TextButton>
      }
    >
      <iframe
        style={{ border: 'none', width: '100%', height: '253px' }}
        src="https://www.youtube.com/embed/gaTjeBR-kwE?si=2hlWGOaNCfwXkf5k"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen={true}
      />
      <p>
        Be aware that the editor is currently in beta and, in its current form,
        is mainly used to collect user suggestions.
      </p>
      <p>
        We are working intensively on the stable version and we will appreciate
        your feedback! 😁
      </p>
      <p>Let's stay in touch:</p>
      <ul>
        <li>
          <Link
            href="https://patchkit.net/support.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Support
          </Link>
        </li>
        <li>
          <Link
            href="https://discord.com/invite/Z5ED24m"
            target="_blank"
            rel="noopener noreferrer"
          >
            Discord
          </Link>
        </li>
      </ul>
    </Dialog>
  );
};

const Link = styled.a`
  color: var(--accent-color);
  text-decoration: none;
  font-weight: bold;
  margin-left: 5px;

  &:hover {
    text-decoration: underline;
  }
`;
